export default __webpack_public_path__ + "static/media/exchange-illustration.265db7fd.png";